import { Checkbox } from '@mui/material'
import type { PropertyInputProps } from '@/objects/property-forms/PropertyInputProps.tsx'
import { ClickableArea } from '@/objects/property-forms/ClickableArea.tsx'

export type TogglePropertyInputProps = PropertyInputProps<boolean>

export function TogglePropertyInput({ value, onValueChange }: TogglePropertyInputProps) {
  return (
    <ClickableArea onClick={() => onValueChange(!value)}>
      <Checkbox checked={value} readOnly sx={{ p: 0, pointerEvents: 'none' }} />
    </ClickableArea>
  )
}
